export var addImageFallback = function (event, fallback) {
    event.currentTarget.src = fallback;
};
